package dk.smark.demo.di

import dk.smark.demo.api.UserApiService
import dk.smark.demo.MainViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val appModule = module {
    single { UserApiService() }
    viewModel { MainViewModel(get()) }
}